<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body" >
      <div>
        <div class="row no-gutters">
          <div class="col-md-12 text-center modal-header align-items-center px-4">
            <div class="header-container row w-100 py-3">
              <h3 class="col-10 text-left section-title">Case status: {{ caseNumber.toUpperCase() }}</h3>
              <button class="close close-btn text-right col-1" :disabled="isRITMStatusLoading" @click="$emit('close')">
                <img src="../assets/images/icon-close.svg" />
              </button>
            </div>
          </div>
        </div>
        <div class="row no-gutters ritm-status-container">
          <div class="overlay-loader-container w-100 text-center pt-5" v-if="isRITMStatusLoading">
            <img class="overlay-loader loading-spinner" :src="CONSTANTS.SPINNER_URL" alt="Loading Spinner">
          </div>

          <div class="col-12" v-else>
            <div class="alert-container mb-2" v-if="errorMessage">
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{errorMessage}}</strong></div>
              </div>
            </div>

            <div v-if="!isRITMStatusLoading && !errorMessage && dataExists">
              <div class="parent-case-container">
                <div class="row">
                  <div class="col-12 pb-2 case-details-title">
                    {{CONSTANTS.SUPPLIER_ENGAGEMENT_SHORT_DESC}}
                  </div>
                  <div class="col-md-6 py-2" v-for="(obj, index) in parentCaseData" :key="index">
                    <div class="parent-case-title eh-font-bold">
                      {{ obj.key }}
                    </div>
                    <div class="parent-case-value">
                      <div v-if="obj.key === 'Created by'">
                        <user-full-name :user-detail="userData(obj.value)" />
                      </div>
                      <div v-else>
                        {{obj.value}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 py-2" v-if="isOnBoardingStatusLoaded">
                    <div class="parent-case-title eh-font-bold">
                      <header-with-tooltip :tooltip-text="CONSTANTS.SUPPLIER_ONBOARDING_TRACKER.TOOLTIP"> {{CONSTANTS.SUPPLIER_ONBOARDING_TRACKER.TITLE}} </header-with-tooltip>
                    </div>
                    <div class="parent-case-value">
                        <span v-if="getOnBoardingStatusFor(this.caseNumber)">
                            {{ getOnBoardingStatusFor(this.caseNumber) }}
                            <div v-if="getVendorIdFor(this.caseNumber)">
                                  Supplier ID: {{ getVendorIdFor(this.caseNumber) }}
                            </div>
                        </span>
                    </div>
                  </div>
                </div>
              </div>


              <div v-for="(ritm, index) in childRITMStatuses" :key="index" class="m-4">
                <div class="row no-gutters">
                  <div class="col-md-1 col-2 text-center align-self-center">
                    <font-awesome-icon v-if="ritm.status === 'Completed'"
                        :icon="['far', 'check-circle']"
                        size="2x"
                        class="completed-check-circle" />
                    <font-awesome-icon v-else
                                       :icon="['far', 'circle']"
                                       size="2x"
                                       class="disabled-check-circle" />
                  </div>
                    <div class="col-md-11 col-10 p-md-4 p-3" :class="getCardByStatus(ritm)">
                      <div class="row no-gutters">
                        <div class="col-md-8 col-9 ritm-description">
                          {{ritm.description}}
                          <div class="ritm-status">
                            {{ritm.status}}
                          </div>
                          <div class="ritm-status" v-if="ritm.apexStatus">
                            Supplier Setup Status: <span class="eh-font-bold">{{ritm.apexStatus}}</span>
                          </div>
                          <div>
                            <span class="task-desc-link " @click="showTaskDescription(ritm.description)">Show Task Description  <font-awesome-icon v-if="showDesc.includes(ritm.description)" icon='chevron-up' size="sm"/> <font-awesome-icon v-else icon='chevron-down' size="sm"/></span>
                          </div>
                          <div class="ritm-status" v-if="showDesc.includes(ritm.description)">
                            <div v-html="CONSTANTS.CHILD_CASE_TOOLTIP[ ritm.description.includes('Security Assessment') ? 'Security Assessment' : ritm.description]" ></div>
                            
                          </div>
                        </div>
                        <div class="col-md-4 col-3" v-if="ritm.assignedTo">
                          <user-full-name :user-detail="userData(ritm.assignedTo)" />
                      </div>
                      <div class="col-md-4 col-3" v-else>
                        <span>None</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="!isRITMStatusLoading && !errorMessage && !dataExists">
              <div class="p-4 ml-4 font-weight-bold">
                <span v-if="isSupplierCentralRITM">
                  Case creation is in progress. Please check back in a minute.
                </span>
                <span v-else>
                  No data exists for {{caseNumber}}.
                </span>
              </div>
            </div>
            <div class="pt-2 pl-4 m-4" v-if="dataExists">
              <span class="options-link" @click="routeToQuestionnaire">View submitted questionnaire</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row buttons-group no-gutters justify-content-end pb-4 px-md-0 px-3 ml-md-0 ml-3">
      <button :disabled="isRITMStatusLoading" class="btn-container flat-btn gray-btn close-btn btn mx-3" @click="$emit('close')">Close</button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Constants from "@/store/constants";
import UserFullName from "@/components/UserFullName";
import { mapGetters, mapActions } from "vuex"
import SupplierOnboardStatusTrackerMixin from "@/mixins/SupplierOnboardStatusTrackerMixin";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";

export default {
  name: "AgentRITMStatusModal",
  props: ["caseNumber"],
  components: {HeaderWithTooltip, UserFullName},
  mixins: [SupplierOnboardStatusTrackerMixin],
  created() {
    this.initializeData()
    this.initializeOnBoardingStatus()

  },
  computed: {
    ...mapGetters(['userData','onBoardingCompletedRequests'])
  },
  data() {
    return {
      isRITMStatusLoading: false,
      errorMessage: '',
      childRITMStatuses: [],
      dataExists: true,
      parentCaseData: [],
      isSupplierCentralRITM: false,
      RITM_STATUS: {
        COMPLETED: "Completed",
        NOT_APPLICABLE: "Not applicable"
      },
      /*flag to ensure new supplier setup tracker is only shown for completed case modal*/
      isOnBoardingStatusLoaded: false,
      showDesc:[]
    }
  },
  methods: {
    ...mapActions(['fetchAllOnBoardingRequests']),
    /*css styles by current child case status*/
    getCardByStatus(card){
      if(card && card.status && card.status.toLowerCase() === this.RITM_STATUS.COMPLETED.toLowerCase())
        return 'completed-status'
      if(card && card.status && card.status.toLowerCase() === this.RITM_STATUS.NOT_APPLICABLE.toLowerCase())
        return 'not-applicable-status'
      return 'status-card'
    },
    async initializeData() {
      this.isRITMStatusLoading = true
      try {
        await this.setParentCaseData()
        const response = await api.getAgentCaseStatus(this.caseNumber)
        const apexResponse = await api.getApexStatus(this.caseNumber);
        if(response && response.data && response.data.result && response.data.result.length > 0) {
          let childRITMS = response.data.result
          childRITMS.forEach((ritm) => {
            this.childRITMStatuses.push({
              description: ritm.short_description,
              status: Constants.AGENT_STATUS_MAP[ritm.u_agent_status],
              apexStatus: ritm.short_description == Constants.APEX_CHILD_TASK ? apexResponse.data.result[0]['u_apex_supplier_status']:undefined,
              assignedTo: ritm['assigned_to.user_name']
            })
          })
        } else {
          this.dataExists = false
        }
      } catch(error) {
        this.errorMessage = Constants.ERROR_MESSAGE
      } finally {
        this.isRITMStatusLoading = false
        let subEvent = `caseNumber - ${this.caseNumber}`
        this.$hhMixpanel.trackEvent('Supplier Central - Case status', { subEvent : subEvent });
      }
    },
    async initializeOnBoardingStatus() {
      this.isOnBoardingStatusLoaded = false
      if(this.onBoardingCompletedRequests.length === 0) {
        await this.fetchAllOnBoardingRequests(false)
        await this.fetchSupplierOnBoardingStatus()
      }
      if(this.onBoardingCompletedRequests.find(request => request.caseNumber === this.caseNumber)) {
        this.isOnBoardingStatusLoaded = true
      }
    },
    async setParentCaseData() {
      let parentCaseData = []
      let response = ''
      try {
        response = await api.getParentCaseData(this.caseNumber)
      } catch (error) {
        this.errorMessage = Constants.ERROR_MESSAGE
      } finally {
        if(response && response.data && response.data.result && response.data.result.length > 0) {
          this.isSupplierCentralRITM = response.data.result[0].short_description === Constants.SUPPLIER_ENGAGEMENT_SHORT_DESC
          parentCaseData.push(
              {
                key: "Created by",
                value: response.data.result[0].sys_created_by
              },
              {
                key: "Created on",
                value: response.data.result[0].sys_created_on.substr(0, 10)
              },
              {
                key: "Case status",
                value: this.formatStatus(response.data.result[0].state)
              },
              {
                key:"Form type",
                value: this.formatStatus(response.data.result[0].u_request_exit_point)
              })
        }
        this.parentCaseData = parentCaseData
      }
    },
    formatStatus(status) {
      return status.charAt(0).toUpperCase() +
          status.substring(1).toLowerCase()
    },
    routeToQuestionnaire() {
      let exitPoint = this.parentCaseData.find(data => data.key === 'Form type')
      this.$parent.$emit('onRouteToQuestionnaire', this.caseNumber, exitPoint.value)
    },
    showTaskDescription(title){
      this.showDesc=this.showDesc.includes(title)?[]:[title]
    }
  }
}
</script>

<style scoped>
.ritm-status-container {
  min-height: 300px;
  max-height: 70vh;
  overflow-y: auto;
}

.ritm-description {
  font-size: 18px;
  font-family: artifaktElementBold;
}

.ritm-status {
  font-size: 14px;
  font-family: artifaktElementRegular;
  margin-top: 5px;
}

.completed-status {
  border: 1px solid #87bc40;
}

.not-applicable-status {
  border: 1px solid #b0b0b0;
  color: #939393;
}

.modal-header {
  height: 100%;
}

.completed-check-circle {
  color: #87bc40
}

.disabled-check-circle {
  color: #b0b0b0;
}

.status-card {
  border: 1px solid #b0b0b0;
}

.parent-case-container {
  background-color: #E7F4FF;
  padding: 30px 45px;
}

.case-details-title {
  font-size: 20px;
}
</style>